import getIn from 'transmute/getIn';
import get from 'transmute/get';
import { Map as ImmutableMap } from 'immutable';
export function getTimelineItemId(timelineItem) {
  if (!ImmutableMap.isMap(timelineItem)) {
    return null;
  }
  const id = getIn(['engagement', 'id'], timelineItem) || getIn(['eventData', 'engagement', 'id'], timelineItem) || getIn(['eventData', 'id'], timelineItem) || get('id', timelineItem);
  return `${id}`;
}